import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DynamicComponentDirective,
  HasFeatureDirective,
  HorizontalScrollDirective,
  ImgMagnifierDirective,
  MaskErrorTooltipDirective,
  OverflowListenerDirective,
  ScrollListenerDirective,
} from './directives';

@NgModule({
  declarations: [
    MaskErrorTooltipDirective,
    HasFeatureDirective,
    ImgMagnifierDirective,
    DynamicComponentDirective,
    HorizontalScrollDirective,
    OverflowListenerDirective,
    ScrollListenerDirective,
  ],
  imports: [CommonModule],
  exports: [
    MaskErrorTooltipDirective,
    HasFeatureDirective,
    ImgMagnifierDirective,
    DynamicComponentDirective,
    HorizontalScrollDirective,
    OverflowListenerDirective,
    ScrollListenerDirective,
  ],
})
export class DirectivesModule {}
